import { render, staticRenderFns } from "./ApprovalConfig.vue?vue&type=template&id=12f650f4&scoped=true"
import script from "./ApprovalConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfig.vue?vue&type=style&index=0&id=12f650f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f650f4",
  null
  
)

export default component.exports